import ACL_RELATIONSHIPS from "acl-relationships";
import useAuthorized from "hooks/useAuthorized";
import { useRuvixxFlags } from "providers/RuvixxFlagsProvider";

// The status picker lists the Meta Leads Events, so setting a status also
// needs the permission to read them.
export default function useCanSetRegistrantLeadStatus() {
  const { enable_leads_feature } = useRuvixxFlags();
  const isAuthorized = useAuthorized([
    ACL_RELATIONSHIPS.lead.setSwoogoRegistrantLeadStatus,
    ACL_RELATIONSHIPS.metaLeadsEvent.read,
  ]);
  return Boolean(enable_leads_feature) && isAuthorized;
}
